import React from 'react';
import TrueImpactText from 'shared/design-system/base/TrueImpactText';
import TrueImpactButton from 'shared/design-system/components/TrueImpactButton';
import { COLORS } from 'shared/design-system/settings/variables/Colors';
import { SPACERS } from 'shared/design-system/settings/variables/Spacers';
import styled from 'styled-components';
import FeedbackTemplates from './FeedbackTemplates';
import { UserType } from './utils';

interface FeedbackTextareaButtonsProps {
  isEmpty: boolean;
  isSaving: boolean;
  userType: UserType;
  errorMessage?: string;
  handleSave: () => unknown;
  handleChange: (text: string) => unknown;
  onClear: () => unknown;
}

const StyledDiv = styled.div<{ hidePadding: boolean }>`
  ${({ hidePadding }) =>
    hidePadding ? '' : `padding: 14px ${SPACERS.medium};`}
  background-color: ${COLORS.grayLight};
  .error-message {
    margin-bottom: 14px;
  }
  .text-area-buttons {
    display: flex;
    .save-button {
      margin-right: ${SPACERS.small};
    }
  }
`;

const FeedbackTextareaButtons: React.FC<FeedbackTextareaButtonsProps> = ({
  userType,
  isSaving,
  isEmpty,
  errorMessage,
  handleSave,
  handleChange,
  onClear,
}) => {
  return (
    <StyledDiv hidePadding={isEmpty && userType !== 'ti staff'}>
      {isEmpty ? (
        <FeedbackTemplates userType={userType} handleChange={handleChange} />
      ) : (
        <>
          {errorMessage && (
            <TrueImpactText color="critical" className="error-message">
              {errorMessage}
            </TrueImpactText>
          )}
          <div className="text-area-buttons">
            <TrueImpactButton
              className="save-button"
              disabled={isSaving}
              onClick={handleSave}
            >
              {isSaving ? 'Saving' : 'Save'}
            </TrueImpactButton>
            <TrueImpactButton
              variant="secondary-large"
              disabled={isSaving}
              onClick={onClear}
            >
              Clear
            </TrueImpactButton>
          </div>
        </>
      )}
    </StyledDiv>
  );
};

export default React.memo(FeedbackTextareaButtons);
